<template>
  <div>
    <b-table
      :items="records"
      :fields="fields"
      :busy="isLoaging"
      class="col-12 mt-2 table-views"
      show-empty
    >
      <template #empty>
        <div class="text-center my-2">
          <h3>No hay exámenes registrados</h3>
        </div>
      </template>

      <template #table-busy>
        <div class="text-center my-2 mb-3">
          <overlay-button></overlay-button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import Pagination from "laravel-vue-pagination";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
export default {
  components: {
    Pagination,
    OverlayButton,
  },
  props: {
    records: {
      type: Array,
      default: () => []
    },
    isLoaging: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      fields: [
        {
          label: "Fecha y hora",
          key: "event_date",
        },
        {
          label: "Nombre del archivo",
          key: "name_file",
        },
        {
          label: "Evento",
          key: "event",
        },
        {
          label: "Razón",
          key: "reason",
        },
        {
          label: "Abogado",
          key: "user_name",
        },
      ],
    };
  },
};
</script>

<style lang="css">
.custom-tooltip-ht .tooltip-inner {
  max-width: 200px !important;
  background-color: #263238 !important;
  font-size: 14px !important;
}
.text-file {
  color: #1719da80;
  font-size: 16px;
  cursor: pointer;
}
.list-diagnostic {
  list-style: disc !important;
  padding: 0 !important;
}
.list-diagnostic li {
  overflow: hidden;
  width: 250px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>
